import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NO_SCROLL_TOP_PATHS = new Set([
  // These routes all render `Freelancer` and handle their own scroll-to-section.
  '/services',
  '/process',
  '/cases',
  '/faq',
  '/work-experience',
  '/projects',
  '/contact',
  '/contact-section',
]);

const PageScrollTop = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (NO_SCROLL_TOP_PATHS.has(pathname)) return;
    window.scrollTo(0, 0);
  }, [pathname]);

  return children;
};

export default PageScrollTop;
